import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Renderer2,
    Self,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { BazisConfigurationService, SHARE_REPLAY_SETTINGS } from '@bazis/configuration.service';
import { BazisListService } from '@bazis/list/services/list.service';
import { EntData } from '@bazis/shared/models/srv.types';
import { BazisEntityService } from '@bazis/shared/services/entity.service';
import { BazisMediaQueryService } from '@bazis/shared/services/media-query.service';
import { combineLatest, Observable, of, shareReplay, switchMap } from 'rxjs';
import { BazisAutocompleteComponent } from '@bazis/form/components/base/autocomplete/autocomplete.component';

@Component({
    selector: 'bazis-autocomplete-grouped',
    templateUrl: './autocomplete-grouped.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisAutocompleteGroupedComponent extends BazisAutocompleteComponent {
    // TODO: проверить в MP, используется ли здесь staticOptions

    selectedList$: Observable<EntData[]>;

    constructor(
        @Self() public ngControl: NgControl,
        protected cdr: ChangeDetectorRef,
        public configurationService: BazisConfigurationService,
        entityService: BazisEntityService,
        mqSrv: BazisMediaQueryService,
        renderer: Renderer2,
        public list: BazisListService,
    ) {
        super(ngControl, cdr, configurationService, entityService, mqSrv, renderer);
    }

    extendOnInit(): void {
        // компонент не имеет смысла, если не мультиплай. В этом случае - это обычный автокомплит
        this.multiple = true;

        if (this.emptyValue) {
            this.emptyValueEntity = this.entityService.toEntityItem(this.emptyValue);
        }

        if ((!this.searchSettings || !this.searchSettings.entityType) && this.entityType) {
            this.searchSettings = {
                ...this.searchSettings,
                entityType: this.entityType,
            };
        }

        if (!this.entityType && this.searchSettings.entityType) {
            this.entityType = this.searchSettings.entityType;
        }

        this.selectedList$ = this.values.$.pipe(
            switchMap((ids) => {
                if (ids.length === 0) return of([]);
                const dynamicIds = this.staticOptionsEntities.length
                    ? ids.filter(
                          (v) => this.staticOptionsEntities.findIndex((ent) => ent.id === v) === -1,
                      )
                    : ids;
                const staticEntities$ =
                    this.staticOptionsEntities.length > 0
                        ? ids
                              .map((v) =>
                                  this.staticOptionsEntities.find((entity) => entity.id === v),
                              )
                              .filter((v) => !!v)
                              .map((v) => of(v))
                        : [];

                return combineLatest([
                    ...staticEntities$,
                    ...dynamicIds.map((id) =>
                        this.searchSettings.entityType !== 'organization.organization_info'
                            ? this.entityService.getEntity$(this.searchSettings.entityType, id)
                            : this.entityService.getOrganizationEntity$(id),
                    ),
                ]);
            }),
            shareReplay(SHARE_REPLAY_SETTINGS),
        );

        this._isInited = true;
    }

    toggleSelectedValue(item, event) {
        event.stopPropagation();
        super.toggleValue(item.id);
        // this.setControlValue(item);
        this.list.updateFilter();
    }
}
